import { useTranslation } from 'react-i18next'
import { Select } from '@/components/v2/ui/Select'
import { useChannels } from '@/hooks/useChannels'

interface SegmentRuleChannelPickerProps {
  channelId?: string
  onChange: (channelId: string) => void
}

/** Channel dropdown for channel-capable segment conditions (channel_quantity_30d, channel_revenue_30d, listed_on_channel). */
export function SegmentRuleChannelPicker({ channelId, onChange }: SegmentRuleChannelPickerProps) {
  const { t } = useTranslation()
  const { data: channels } = useChannels()
  const options = (channels ?? []).map((c) => ({
    value: c.id,
    label: c.custom_name || c.channel_name,
  }))

  return (
    <div className="w-full sm:w-56 shrink-0">
      <Select
        data-testid="rule-channel"
        options={options}
        value={channelId ?? ''}
        onValueChange={onChange}
        placeholder={t('productSegments.builder.channelPlaceholder')}
        aria-label={t('productSegments.builder.channelLabel')}
      />
    </div>
  )
}

SegmentRuleChannelPicker.displayName = 'SegmentRuleChannelPicker'
